import { IconButton } from "@material-ui/core"
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined"
import React, { useState } from "react"
import styled from "styled-components"
import { Slide } from "../slides/Slide"
import { CenterPiece } from "../styles"

export const Wrap = styled(CenterPiece)`
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;

  div {
    margin: 0;
  }

  font-size: ${props => (props?.isFooter ? "14px" : "18px")};

  @media (max-height: 800px) {
    font-size: ${props => (props?.isFooter ? "12px" : "16px")};
  }
`
const Right = styled.div`
  height: 100%;
  display: flex;
  align-items: start;
  justify-content: end;
  padding-right: 5px;
  padding-top: 5px;
`

const Body = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 10px 0px 10px;
`

const CloseButton = styled(IconButton)`
  height: 30px;
  width: 30px;
`

export const InfoContent = props => {
  const [currentSlide] = useState(0) //todo-nice-to-have = uitbreiden naar meerdere slides
  const content = props?.gameData?.game_info_popup?.popup_content || []
  const handleClick = () => {
    if (props.onClose) {
      props.onClose()
      return
    }
  }

  return (
    <Wrap isFooter={props.isFooter}>
      <Body>
        <Slide slide={content[currentSlide]} {...props} />{" "}
      </Body>
      <Right>
        <CloseButton onClick={handleClick}>
          <CloseOutlinedIcon fontSize="small" />
        </CloseButton>
      </Right>
    </Wrap>
  )
}
